import React from "react";
import {Tooltip} from "../../Tooltip/Tooltip";

export const GradeBadge = ({ label, Rating, Value, Justification }) => {
  return (
      <Tooltip text={Justification || "No justification provided"}>
        <span className={`Badge ${ Rating?.toLowerCase()?.replace(/ /g, "_") ?? "not_available" }`}>
          {label}: {
            Value
              ? Value
              : Rating
                ? Rating
                : "Not available"
          }
        </span>
      </Tooltip>
  );
};
